import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <Route
    key="/business/technologies/agile-hand-tracking"
    element={<DefaultBusinessLayout />}
  >
    <Route
      path="business/technologies/agile-hand-tracking"
      element={<AsyncPage />}
    />
  </Route>,
];
